import { GET, POST, PUT, RBAC_API } from '../constants';
import { jwtTokenHeader, request } from '../utils';

export async function getAllUsers() {
  return request(GET, `${RBAC_API}/v1/users`, {}, await jwtTokenHeader(), 'Failed to fetch Users');
}

export async function getAllRoles() {
  return request(GET, `${RBAC_API}/v1/roles`, {}, await jwtTokenHeader(), 'Failed to fetch Roles');
}

export async function addUser({ emailId, roleIds }) {
  const payload = [
    {
      'email-id': emailId,
      'role-ids': roleIds,
    },
  ];
  return request(POST, `${RBAC_API}/v1/users`, payload, await jwtTokenHeader());
}

export async function getUserId(emailId) {
  const url = `${RBAC_API}/v1/users/${encodeURIComponent(emailId)}`;
  return request(GET, url, {}, await jwtTokenHeader(), 'Failed to fetch user ID');
}
export async function updateUser({ emailId, roleIds, userId }) {
  const uniqueRoleIds = Array.from(new Set(roleIds.map((role) => role.id)));
  const payload = {
    'email-id': emailId,
    'role-ids': uniqueRoleIds,
  };
  return request(
    PUT,
    `${RBAC_API}/v1/users/${encodeURIComponent(userId)}`,
    payload,
    await jwtTokenHeader(),
    'Failed to update user'
  );
}
